import React from 'react';
import { Container, Stack, useTheme } from '@mui/system';
import { Box, Typography } from '@mui/material';

const troubleshooting = [
  {
    question: `My game seems laggy`,
    answer: `The game can lag for two reasons:
    
    1) The server is struggling. You can usually tell it's the server's fault if the questions and gameclock seem choppy and time seems to move more slowly in the game. So let's say the gameclock displays :01 and then display :02, but more than 1 second has passed, then the server is bottlenecked. Let us know in the Discord if you think this is happening
    
    2) It's on your end (client-side). You can tell that the problem is client-side if your game seems choppy, but the correct amount of time has passed. So let's say the gameclock display :01 and then skips to :03, but exactly 2 seconds have passed, then the server is running fine. If your wifi connection is unstable, you might notice choppiness. Or if your computer is working hard, say you have a bunch of apps and tabs open, this could impact your browser performance. Try closing unused apps and then refreshing your browser.`,
  },
  {
    question: `I'm on a vpn`,
    answer: `Depending on your VPN provider, some can have very high traffic, especially during peak hours. This can cause PAR to run a little "jittery" (questions not displaying smoothly). We're working on optimizing so this doesn't matter, but you can try getting off the VPN to see if it helps.`,
  },
  {
    question: `I can't join games / PAR thinks I'm already in a game`,
    answer: `This can happen from time to time while we are still working out the kinks. Contact the Discord and an admin will refresh your game state in the server.`,
  },
];

const mobile = [
  {
    question: `Mobile barely works`,
    answer: `Mobile support is minimal at the moment. We are a very small technical team and are prioritizing the webapp first. We are 100% going to improve the mobile experience down the road`,
  },
];

export const Troubleshooting = () => {
  return (
    <Container sx={{ paddingBottom: 10 }}>
      <Typography variant="h4" textAlign={'center'} mb={4}>
        Troubleshooting
      </Typography>
      <Typography variant="h5" fontWeight={600} mb={2} color="secondary.main">
        Game
      </Typography>
      {troubleshooting.map((o) => (
        <>
          <Stack direction={'row'} spacing={1} mt={2}>
            <Typography color="success.main">Q:</Typography>
            <Typography variant="body1">{o.question}</Typography>
          </Stack>
          <Stack direction={'row'} spacing={1} mt={1} mb={1}>
            <Typography color="ranked.main">A:</Typography>
            <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
              {o.answer}
            </Typography>
          </Stack>
        </>
      ))}
      <Typography
        variant="h5"
        fontWeight={600}
        mb={2}
        mt={4}
        color="secondary.main"
      >
        Mobile
      </Typography>
      {mobile.map((o) => (
        <>
          <Stack direction={'row'} spacing={1} mt={2}>
            <Typography color="success.main">Q:</Typography>
            <Typography variant="body1">{o.question}</Typography>
          </Stack>
          <Stack direction={'row'} spacing={1} mt={1} mb={1}>
            <Typography color="ranked.main">A:</Typography>
            <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
              {o.answer}
            </Typography>
          </Stack>
        </>
      ))}
    </Container>
  );
};
